import { mountGarageShell, type GarageShellHandle } from './GarageShell.js';

let shellHandle: GarageShellHandle | null = null;

/**
 * Monte le garage unifié (rail · liste · détail).
 * Les appels suivants (navigation interne `#garage/...`) resynchronisent le hash.
 */
export function mountGarageApp(root: HTMLElement): void {
  if (shellHandle && shellHandle.getElement().isConnected) {
    shellHandle.syncFromHash();
    return;
  }
  shellHandle = mountGarageShell(root);
}
